import { useLazyQuery } from "@apollo/client/react";import React, { useEffect, useState } from 'react';
import './indicacionDetalle.scss';
import { Grid } from '@mui/material';
import { GET_ADMIN_INDICACION_DETALLE_PROF } from '../../../../data/graphQL/queries/AdminIndicacion/getAdminIndicacionDetalleProf';


export const IndicacionDetalleProfesionales = ({ indicacion }) => {
  const [profesionales, setProfesionales] = useState([]);

  useEffect(() => {
    if (!profesionalesLoading)
    getProfesionales({variables: { idIndicacionAprobacion: indicacion?.idIndicacionAprobacion }});
  }, []);

  const [getProfesionales, { data: dataProfesionales, loading: profesionalesLoading }] = useLazyQuery(GET_ADMIN_INDICACION_DETALLE_PROF, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataProfesionales) return;
    if (dataProfesionales.adminIndicacionDetalleProf.success) {
      setProfesionales(dataProfesionales.adminIndicacionDetalleProf.valorEsperado);
    }
  }, [dataProfesionales]);

  return (
    <Grid container className='contrato-card-white'>
            <Grid size={{ xs: 12 }}>
                <div className='section-title'>Profesionales asignados</div>
            </Grid>
            <Grid container spacing={1} size={{ xs: 12 }}>
                {
        profesionales.length > 0 &&
        profesionales.map((item, index) =>
        <Grid size={{ xs: 12, md: 2 }} key={index}>
                            <div><strong>{item.tipo}</strong> {item.total}</div>
                        </Grid>
        )
        }
                {
        profesionales.length == 0 && <Grid size={{ xs: 12, md: 2 }} key={0}><div>-</div></Grid>
        }
            </Grid>
        </Grid>);

};